import { Button } from '@thanx/uikit/button'
import { Text } from '@thanx/uikit/text'
import LiveUpdatesDisabledIllustration from 'components/LiveUpdatesDisabledBanner/Illustration'
import ModalContainer from 'components/ModalContainer'
import { LIVE_UPDATES_PATH } from 'constants/liveUpdates'
import palette from 'constants/palette'
import { useCanOpenLiveUpdates } from 'hooks/useCanOpenLiveUpdates'
import { buildTranslate } from 'locales'
import React from 'react'
import { Link } from 'react-router-dom'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('recovery_ai.activation.live_updates_required')

const DIALOG_WIDTH = '480px'

const LINK_RADIUS = '4px'
const LINK_PADDING_Y = '10px'
const LINK_PADDING_X = '24px'
const CONTENT_GAP = '16px'

interface Props {
  isOpen: boolean
  onClose: () => void
}

const LiveUpdatesRequiredModal = ({ isOpen, onClose }: Props) => {
  const [css] = useStyletron()
  // Without MerchantSettings the Live updates page redirects to /unauthorized,
  // so the link is left out and the modal only offers "Not now".
  const canOpenLiveUpdates = useCanOpenLiveUpdates()

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onClose}
      title={t('title')}
      width={DIALOG_WIDTH}
      hideCancel
      showBottomProceed={false}
      buttonGroupChildren={
        <>
          <Button kind="secondary" onClick={onClose}>
            {t('not_now')}
          </Button>
          {canOpenLiveUpdates && (
            <Link
              to={LIVE_UPDATES_PATH}
              onClick={onClose}
              className={`ml-s ${css({
                display: 'inline-block',
                backgroundColor: palette.belizeHole,
                color: palette.white,
                fontWeight: 700,
                paddingTop: LINK_PADDING_Y,
                paddingBottom: LINK_PADDING_Y,
                paddingLeft: LINK_PADDING_X,
                paddingRight: LINK_PADDING_X,
                borderTopLeftRadius: LINK_RADIUS,
                borderTopRightRadius: LINK_RADIUS,
                borderBottomLeftRadius: LINK_RADIUS,
                borderBottomRightRadius: LINK_RADIUS,
                textDecoration: 'none',
                ':hover': { color: palette.white },
              })}`}
            >
              {t('go_to_live_updates')}
            </Link>
          )}
        </>
      }
    >
      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          gap: CONTENT_GAP,
        })}
      >
        <LiveUpdatesDisabledIllustration testId="live-updates-required-illustration" />
        <Text.BodyText3 tag="div" color="grey70">
          <Text.BodyText3 tag="span" bold color="grey90">
            {t('body_lead')}
          </Text.BodyText3>{' '}
          {t('body')}
        </Text.BodyText3>
      </div>
    </ModalContainer>
  )
}

export default LiveUpdatesRequiredModal
